/*
 * File: /apps/web/src/tasker/redux/modules/taskerProfile.js
 * Project: tr-web
 * Created Date: 2020-08-03
 * Author: Raif
 *
 * Copyright (c) 2020 TaskRabbit, Inc
 */

import xhr from "util/xhr";
import {
  RESCUE_PROFILE_RECOMMENDATION,
  TASKER_PROFILE_BY_SLUG_OR_ID,
} from "tasker/routes/apiRoutes";
import { createActionTypesFor } from "util/reducerHelpers";
import { DateTime } from "luxon";
import { mapResponseToProfile } from "../selectors/mapResponseToProfile";
import { featureFlags } from "enums/featureFlags";
import { fetchEnabledFeatures } from "../../../build/util/getEnabledFeatures";

const TASKER_PROFILES = createActionTypesFor("taskerProfile", "taskerProfile");

export const RESCUE_PROFILE = createActionTypesFor(
  "rescueProfile",
  "rescueProfile"
);

const initialState = {
  loading: false,
  rescueProfileId: "",
  variationDateRanges: [],
  profiles: [],
};

// eslint-disable-next-line @typescript-eslint/default-param-last
export default function taskerProfile(state = initialState, action) {
  switch (action.type) {
    case TASKER_PROFILES.REQUEST: {
      return { ...state, loading: true };
    }
    case TASKER_PROFILES.SUCCESS: {
      let exists = false;
      const updatedProfiles = state.profiles.map((x) => {
        if (x.taskerId === action.profile.taskerId) {
          exists = true;
          return action.profile;
        }
        return x;
      });

      if (exists) {
        return { ...state, profiles: updatedProfiles, loading: false };
      }
      return {
        ...state,
        profiles: [...state.profiles, action.profile],
        loading: false,
      };
    }
    case TASKER_PROFILES.FAILURE: {
      return { ...state, loading: false };
    }
    case RESCUE_PROFILE.REQUEST: {
      return { ...state, loading: true };
    }
    case RESCUE_PROFILE.SUCCESS: {
      let exists = false;
      if (!action.profile) {
        return { ...state };
      }

      const updatedProfiles = state.profiles.map((x) => {
        if (x.taskerId === action.profile.taskerId) {
          exists = true;
          return action.profile;
        }
        return x;
      });
      let variationDateRange = action.variationDateRange == "" ? "" : action.variationDateRange
      if (exists) {
        return {
          ...state,
          profiles: updatedProfiles,
          variationDateRanges: [...state.variationDateRanges, variationDateRange],
        };
      }
      return {
        ...state,
        profiles: [...state.profiles, action.profile],
        variationDateRanges: [...state.variationDateRanges, variationDateRange],
      };
    }
    default:
      return state;
  }
}

export const fetchTaskerProfile = (slugOrId) => {
  return async (dispatch) => {
    dispatch({
      type: TASKER_PROFILES.REQUEST,
    });
    try {
      const data =
        (await xhr.get(TASKER_PROFILE_BY_SLUG_OR_ID(slugOrId)))
          ?.camelCasedData || {};
      dispatch({
        type: TASKER_PROFILES.SUCCESS,
        profile: mapResponseToProfile(data),
      });
    } catch (ex) {
      dispatch({ type: TASKER_PROFILES.FAILURE, data: ex });
    }
  };
};

export const fetchTaskerRescueProfile = (categoryId, jobId) => {
  return async (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: RESCUE_PROFILE.REQUEST,
      jobId,
    });

    const enabledFeatures = await fetchEnabledFeatures({
      categoryId,
      metroId: state.user.metroId,
    });

    const params = {
      fixed_rate: enabledFeatures?.includes(
        featureFlags.bookingAutoInviteLite
      ),
    };

    const result =
      (await xhr.get(RESCUE_PROFILE_RECOMMENDATION(jobId), { params }))
        ?.camelCasedData || {};
    let variationDateRange = result.variationDateRange;
    let profile;
    if (result.recommendedRabbit) {
      profile = mapResponseToProfile(result.recommendedRabbit);
    }

    dispatch({
      type: RESCUE_PROFILE.SUCCESS,
      variationDateRange: variationDateRange == null ? "" : { jobId: jobId, variationDateRange: variationDateRange },
      profile,
      jobId,
      timestamp: DateTime.now(),
    });
  };
};